'use client';

import { useCallback, useMemo, useRef } from 'react';

import { Box, Button } from '@packages/ui';
import { Locale } from 'i18n-config';
import { usePathname, useRouter } from 'next/navigation';

import ComponentDropdown, {
  IComponentDropdownOptions,
  IComponentDropdownRefProps,
} from 'components/Dropdown';

export default function LocaleSwitcher({ lang }: { lang: Locale }) {
  const pathname = usePathname();
  const componentLanguageDropdownRef = useRef<IComponentDropdownRefProps>(null);
  const router = useRouter();

  const handleLanguageChange = useCallback(() => {
    const newLang = lang === 'fr' ? 'nl' : 'fr';
    const currentPathnameSegments = pathname.split('/');
    const updatedPathname = `/${newLang}/${currentPathnameSegments
      .slice(2)
      .join('/')}`;
    router.replace(updatedPathname);
  }, [lang, pathname, router]);

  const localeDropdownOptions = useMemo(() => {
    const options: IComponentDropdownOptions[] =
      lang === 'fr'
        ? [
            {
              label: 'NL',
              onClick: () => handleLanguageChange(),
            },
          ]
        : [
            {
              label: 'FR',
              onClick: () => handleLanguageChange(),
            },
          ];
    return options;
  }, [handleLanguageChange, lang]);

  return (
    <Box>
      <Button
        className="rounded text-white"
        design="outline"
        onClick={() => componentLanguageDropdownRef.current?.open()}
      >
        {lang || 'FR'}
      </Button>
      <ComponentDropdown
        dropdownOptions={localeDropdownOptions}
        position="bottom"
        ref={componentLanguageDropdownRef}
      />
    </Box>
  );
}
